import { IUserMast } from "../../models/UserMast";
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVDropdown } from "../../shared/JVDropdown";
import { Fetch } from "../../shared/Fetch";
import { set } from "date-fns";
import { Toast } from "primereact/toast";
import { log } from "console";
import { useNavigate } from "react-router-dom";

export interface ILeads {
    team_Lead?: number,
    resource_Manager?: number,
    head?: number,
}

const schema = yup.object({
    team_Lead: yup.number().nullable(),
    resource_Manager: yup.number().nullable(),
    head: yup.number().nullable(),
});

export const UserLeads = (loginID: { loginID: number }) => {
    const [userDetails, setUserDetails] = useState({} as IUserMast);
    const [teamLeads, setTeamLeads] = useState<Array<IUserMast>>([]);
    const [resourceManager, setResourceManager] = useState<Array<IUserMast>>([]);
    const [head, setHead] = useState<Array<IUserMast>>([]);
    const [loading, setLoading] = useState(false);
    const toast = useRef<any>(null);
    const navigate = useNavigate();
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<ILeads>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false,
    });

    function onSubmit(data: ILeads) {
        saveToDB(data);
    };

    async function loadUserData() {
        const response = await Fetch("User_Mast/getUsersByLoginID", "GET", null, `loginID=${loginID?.loginID}`, null);
        if (response) {
            const responseData: IUserMast = await response.json();
            setUserDetails(prev => prev = responseData);
        }
    }

    const saveToDB = async (data: ILeads) => {
        let newData: any = data;
        newData.login_ID = loginID?.loginID;
        const response = await Fetch("User_Mast/updateLeads", "PUT", newData, null, null);
        if (response) {
            toast.current.show({ severity: 'success', detail: "Leads Updated Successfully", life: 3000 });
            navigate("/dashboard");
            // props.setReload(!props.reload);
            // onHide();
        } else toast.current.show({ severity: 'error', detail: "Something went wrong", life: 3000 });
    };

    const loadTeamLead = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=teamLead&login_ID=${loginID?.loginID}`, null);
        if (response) {
            const data: IUserMast[] = await response.json();
            setTeamLeads(prev => prev = data);
            // if (props.open && props.singleData?.team_Lead != null && data.length > 0) {
            //     setValue("team_Lead", props.singleData.team_Lead);
            // }
        }
    };
    const loadResourceManager = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=resourceManager&login_ID=${loginID?.loginID}`, null);
        if (response) {
            const data: IUserMast[] = await response.json();
            setResourceManager(prev => prev = data);
            // if (props.open && props.singleData?.resource_Manager != null && data.length > 0) {
            //     setValue("resource_Manager", props.singleData.resource_Manager);
            // }
        }
    };
    const loadHead = async () => {
        const response = await Fetch("DropDown/getLeadsList", "GET", null, `type=head&login_ID=${loginID?.loginID}`, null);
        if (response) {
            const data: IUserMast[] = await response.json();
            setHead(prev => prev = data);
        }
    };
    useEffect(() => {
        console.log(loginID);
        if (loginID?.loginID != null && loginID?.loginID != 0) {
            loadTeamLead();
            loadResourceManager();
            loadHead();
            loadUserData();
        }
    }, [loginID?.loginID]);

    useEffect(() => {
        if (userDetails) {
            if (userDetails.team_Lead != null && teamLeads.length > 0) {
                setValue("team_Lead", userDetails.team_Lead);
            }
            if (userDetails.resource_Manager != null && resourceManager.length > 0) {
                setValue("resource_Manager", userDetails.resource_Manager);
            }
            if (userDetails.head != null && head.length > 0) {
                setValue("head", userDetails.head);
            }
        }
    }, [userDetails, teamLeads, resourceManager, head]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown filter label="Team Lead" control={control} name="team_Lead" error={errors.team_Lead?.message} options={teamLeads} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Team Lead" />
                <JVDropdown filter label="Resource Manager" control={control} name="resource_Manager" error={errors.resource_Manager?.message} options={resourceManager} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Resource Manager" />
                <JVDropdown filter label="Head" control={control} name="head" error={errors.head?.message} options={head} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Head" />
                {/* <JVInput label="YahooID" control={control} name="user_YahooID" error={errors.user_YahooID?.message} /> */}
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => reset({})} type="button"></Button>
                </div>
            </form>
            <Toast ref={toast} />
        </>
    );
}